// import DER from "./DataEstaticaDeRespuestas.json";
// import * as Evento from "./Eventos";
import {
    NotificacionToast,
    NotificacionToastDeCreacion,
    NotificacionToastDeError,
} from "./NotificacionesToast";

import { NivelToast } from "./ConstantesToast";

const NotificacionFlotante = (toast, notificacionToast) => {
    if (notificacionToast instanceof NotificacionToastDeCreacion) {
        toast.current.show({
            severity: NivelToast.EXITO,
            summary: notificacionToast.titulo,
            detail: notificacionToast.mensaje + " " + notificacionToast.id,
            /* summary: DER[Evento.Creado.name].titulo,
            detail:
                DER[Evento.Creado.name][notificacion.data.tipoDeEntidad] +
                notificacion.data.id, */
            life: 6000,
        });
        return;
    }

    if (notificacionToast instanceof NotificacionToastDeError) {
        // let val = DER[TipoDeEvento.Error][evento.data.tipoDeError].mensaje;
        function detallesError() {
            return (
                <div>
                    {notificacionToast.labelCodigoError + notificacionToast.codigoError}
                    <br />
                    {notificacionToast.mensaje}
                </div>
            );
        }
        toast.current.show({
            severity: NivelToast.ERROR,
            summary: notificacionToast.titulo,
            // detail: "",
            detail: detallesError(),
            life: 6000,
        });
        return;
    }

    if (notificacionToast instanceof NotificacionToast) {
        toast.current.show({
            severity: notificacionToast.nivel,
            // severity: "success",
            summary: notificacionToast.titulo,
            detail: notificacionToast.mensaje,
            /* summary: DER[Evento.Creado.name].titulo,
            detail:
                DER[Evento.Creado.name][notificacion.data.tipoDeEntidad] +
                notificacion.data.id, */
            life: 6000,
        });
        return;
    }
};

export default NotificacionFlotante;
